<template>
    <div>
        <webix-ui :config="config" v-model="suppliers"></webix-ui>
    </div>
</template>

<script>
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'

export default {
    data:() => ({
        clickedAction: false,
        config:{
            id: 'suppliersTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'company_name', header:'Company Name', fillspace: true},
                { id: 'company_address', header:'Address', fillspace: 0.6},
                { id: 'tel_no', header:'Contact Number', fillspace: 0.6},
                { id: 'fax_no', header:'Fax', fillspace: 0.6},
                { id: 'company_email', header:'Company Email', fillspace: 0.6},
                { id: 'contact_person', header:'Contact Person', fillspace: 0.6},
                { id: 'activity_description', header:'Supplier Activity Description', fillspace: 0.6},
                { id: 'actions', header:'', fillspace: 0.2,  template: function(){
                    let element = `<i title="View comment" class="webix_icon_hover webix_icon delete_icon fas fa-trash"></i>`;
                    return element;
                }}
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    var el = this.$scope.$parent;
                    setTimeout(()=>{
                        if(el.clickedAction == false){
                            el.$eventHub.$emit('editSupplier', id.row);
                        }
                    }, 50)
                }
            },
            onClick:{},
        },
    }),
    computed:{
        ...facilityAdminState,
        suppliers(){
            let data = [];
            if(this.client_suppliers != null){
                data = this.client_suppliers
            }
            return data;
        }
    },
    methods:{
        ...facilityAdminMethods,
    },
    mounted(){},
}
</script>

<style >
.fa-trash:hover{
    /*color: var(--bs-danger);*/
    cursor: pointer;
}
</style>